import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '🎨',
  title: 'Biblioteca di Attività',
  desc: 'Centinaia di spunti creativi per lezioni fuori dagli schemi.'
}, {
  num: '02',
  emoji: '🧪',
  title: 'Mini Laboratori Scientifici',
  desc: 'Esperimenti rapidi da 15 minuti che non richiedono attrezzature complesse.'
}, {
  num: '03',
  emoji: '📚',
  title: 'Verifiche Express',
  desc: 'Test rapidi di 10 minuti per valutare la comprensione a fine lezione.'
}, {
  num: '04',
  emoji: '🌍',
  title: 'Poster Scientifici',
  desc: "Infografiche ad alta risoluzione da stampare per l'aula."
}, {
  num: '05',
  emoji: '🧠',
  title: 'Mega Pack Mappe Concettuali',
  desc: 'Tutte le mappe del corso in un unico file ottimizzato per la stampa.'
}, {
  num: '06',
  emoji: '📅',
  title: 'Planner Annuale Docente',
  desc: "Il template perfetto per organizzare l'intero anno scolastico."
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="text-center mb-14" data-id="element-14">
          <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main mb-3 tracking-tight" data-id="element-15">
            🔥 6 Bonus Esclusivi
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-16">
            (Valore €67 — GRATIS Oggi)
          </p>
          <p className="text-badge-red font-black text-xl sm:text-2xl line-through opacity-90 drop-shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-17">
            Valore totale: €67
          </p>
        </div>

        <div className="space-y-4" data-id="element-18">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-secondary/30 hover:shadow-[0_10px_30px_rgba(92,203,127,0.15)] group" data-id="element-19">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-20">
                {bonus.emoji}
              </div>

              <div className="flex-1 min-w-0" data-id="element-21">
                <h3 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-22">
                  <span className="text-secondary mr-2" data-id="element-23">{bonus.num}.</span>
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-24">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-secondary/10 text-primary border border-secondary/30 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(92,203,127,0.2)]" data-id="element-25">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}